import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import tradetronWelcome from "./../../../Images/tradetronWelcome.png";
import "./FoxTraderWelcome.css";
function FoxTraderWelcome(props) {
 // console.log(props);
  return (
    <>
      <section className="fox-trader-welcome">
        <Container>
          <Row>
            <Col md={7}>
              <div>
                <h3>{props.data.title}</h3>
                <p>{props.data.content1}</p>
                <p>{props.data.content2}</p>
              </div>
            </Col>
            <Col md={5}>
              <div>
                <img
                  className="img-fluid"
                  src={tradetronWelcome}
                  alt="tradetronWelcome"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default FoxTraderWelcome;
